import { Component } from '@angular/core';

@Component({
  selector: 'widget-card-placeholder',
  styleUrls: ['./widget-card-placeholder.component.scss'],
  templateUrl: './widget-card-placeholder.component.html'
})
export class WidgetCardPlaceholderComponent {}
